export const CLIENT_FEEDBACKS_EDIT_MODAL_NAME = 'clientFeedbacksEdit';
